// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5445":"6423c763769dc192","81599":"cafaa3955f60aec9"}[chunkId] + ".css";
};